import { useMutation, useQueryClient } from '@tanstack/react-query';
import { omit, pick } from 'lodash';
import { toast } from 'react-toastify';

import { Declaration, DeclarationGoods, TemplateType } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient, templateType } from '@utils';

interface HookProps {
  updatedDeclaration: Declaration;
  propertiesToSend: string[];
}

export const updateDeclaration = async ({ updatedDeclaration, propertiesToSend = [] }: HookProps) => {
  const declaration = propertiesToSend.length ? pick(updatedDeclaration, ['_id', ...propertiesToSend]) : updatedDeclaration;

  if (declaration.goodsShipmentItems) {
    // To prevent payload too large errors, don't send data which didn't change on frontend
    declaration.goodsShipmentItems = declaration.goodsShipmentItems.map((item) => {
      if (templateType() === TemplateType.LOW_VALUE_H7) {
        return item;
      }

      return omit(item, ['commodityCode', 'dutiesAndTaxes', 'evalMethodStatisticalValue', 'evalMethodWebValue', 'webScraping']) as DeclarationGoods;
    });
  }

  const result = await apiClient.declarationsCrud.saveDeclaration.mutation({
    params: { id: String(updatedDeclaration._id) },
    body: { declaration },
  });
  if (result.status !== 200) throw result.body;
  return result.body.data;
};

export const useUpdateDeclaration = () => {
  const queryClient = useQueryClient();

  // TODO:
  // dispatch(
  //   updateDeclarationDetails({
  //     ...updatedDeclaration,
  //     virtuals: { ...(updatedDeclaration.virtuals ?? {}), goodsShipmentItemsLength: updatedDeclaration.goodsShipmentItems?.length || 0 },
  //   }),
  // );

  return useMutation({
    mutationFn: updateDeclaration,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.updatedDeclaration._id] });
      toast.success('Declaration updated!');
    },
    onError: (error) => {
      showErrorToast(error, `Error updating the declaration!`);
    },
  });
};
